import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import FullscreenToggle from './FullscreenToggle';
import FunModeToggle from './FunModeToggle';
import UserFooter from './UserFooter';
import ClappsToggle from '../../../shared/ClappsToggle';

const GameFooter: FC = () => {
  const { game } = useGameContext();

  return (
    <div
      className="flex h-14 w-full items-center justify-between"
      data-testid="game-footer"
    >
      <UserFooter />
      <div className="inline-container gap-4">
        <ClappsToggle />
        {game?.hasFunMode && <FunModeToggle />}
        <FullscreenToggle />
      </div>
    </div>
  );
};

export default GameFooter;
